"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickPerson = void 0;
const firebase_1 = require("../../bindings/firebase");
class QuickPerson {
    constructor(org_id, id, data, active) {
        this._parents = [];
        this._children = [];
        this._tags = [];
        this.org_id = org_id;
        this.id = id;
        this.active = !!active;
        this.contact = data.contact;
        this.department = data.department;
        this.group = data.group;
        this.instrument_group = data.instrument_group;
        this.name = data.name;
        this.pictures = data.pictures;
        this.secondary_group = data.secondary_group;
        this.secondary_instrument_group = data.secondary_instrument_group;
        this.person_status = data.person_status;
        this.families = data.families;
        this.member_category = data.member_category;
        this.address = data.address;
        const parentsObj = data.parents || [];
        const childrenObj = data.children || [];
        const tagsObj = data.tags || [];
        if (Array.isArray(parentsObj)) {
            this._parentRefs = parentsObj;
        }
        else {
            this._parentRefs = [
                ...Object.values(parentsObj),
            ];
        }
        if (Array.isArray(childrenObj)) {
            this._childrenRefs = childrenObj;
        }
        else {
            this._childrenRefs = [
                ...Object.values(childrenObj),
            ];
        }
        if (Array.isArray(tagsObj)) {
            this._tags = tagsObj;
        }
        else {
            this._tags = [...Object.values(tagsObj)];
        }
    }
    ref() {
        return (0, firebase_1.fs)()
            .collection('organizations')
            .doc(this.org_id)
            .collection('persons')
            .doc(this.id);
    }
    fullName() {
        if ((!this.name.first_name || this.name.first_name.length === 0) &&
            this.name.last_name) {
            return this.name.last_name;
        }
        if ((!this.name.last_name || this.name.last_name.length === 0) &&
            this.name.first_name) {
            return this.name.first_name;
        }
        return `${this.name.first_name} ${this.name.last_name}`;
    }
    initials() {
        if ((!this.name.first_name || this.name.first_name.length === 0) &&
            this.name.last_name) {
            return this.name.last_name[0];
        }
        if ((!this.name.last_name || this.name.last_name.length === 0) &&
            this.name.first_name) {
            return this.name.first_name[0];
        }
        return `${this.name.first_name[0]}${this.name.last_name[0]}`;
    }
    isParent() {
        var _a;
        return (((_a = this._children) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0;
    }
    isChild() {
        var _a;
        return (((_a = this._parents) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0;
    }
    set children(children) {
        this._children = children;
    }
    set parents(parents) {
        this._parents = parents;
    }
    get parents() {
        return this._parents;
    }
    get parentsRefs() {
        return this._parentRefs || [];
    }
    get children() {
        return this._children;
    }
    get childrenRefs() {
        return this._childrenRefs || [];
    }
    get tags() {
        return this._tags;
    }
    getId() {
        return this.id;
    }
}
exports.QuickPerson = QuickPerson;
//# sourceMappingURL=quickPerson.js.map